 import httpRequest from "../utils/axios.js";
 import config from "./config.js";

 export default {
     receive,
     submitPayOrder,
     addUpdateOilCard,
     repay,
     cancelOrder,
     setOilCard
 }

 /**
  * 领券
  */
 export function receive(rechargeMode, mobile, cardPwd) {
     var url = config.rcoupons;
     var jsondata = {
         rechargeMode: rechargeMode,
         mobile: mobile,
         cdKeys: cardPwd
     };
     return httpRequest.fetchPost(url, jsondata)
 }
 /**
  * 批量绑定实体卡
  */
 export function batchReceive(cardPwd) {
     var url = config.batchCoupons;
     var jsondata = {
         cdKeys: cardPwd
     };
     return httpRequest.fetchPost(url, jsondata)
 } 
 /**
  * 下单
  * productNo  产品ID
  * account    充值账号
  * payMode（wechat：微信支付，coupon：券支付, mix：混合支付）
  * name 持卡人(选填)  
  * couponIds  券 ID
  */
 export function submitPayOrder(Data) {
     var url = config.sumitOrder;
    //  var jsondata = {
    //      productNo: Data.productNo,
    //      payMode: Data.payment_mode
    //  };
    //  if (Data.account != undefined & Data.account != "") {
    //      jsondata.account = Data.account;
    //  }
    //  if (Data.name != undefined & Data.name != "") {
    //      jsondata.name = Data.name;
    //  }
     if (Data.couponIds != undefined & Data.couponIds != "") {
         Data.couponIds = Data.couponIds.split(',');
     }
    Data.payMode = Data.payment_mode
     return httpRequest.fetchPostJson(url, Data)
 }
 /**
  * 添加修改油卡列表
  */
 export function addUpdateOilCard(cardId, cardNum, cardType, cardHolder, cardMobile) {
     var url = config.addUpdateOilCard;
     var jsondata = {
         cardNum: cardNum,
         cardType: cardType,
         cardHolder: cardHolder,
         cardMobile: cardMobile
     };
     if (cardId != undefined && cardId != "") {
         jsondata.cardId = cardId;
         url += "updateOilCard";
         return httpRequest.fetchPatch(url, jsondata)
     } else {
         url += "addOilCard";
         return httpRequest.fetchPost(url, jsondata)
     }
     //getlist


 }
 /**
  * 删除油卡
  */
 export function deleteOilCard(cardId) {
     var url = config.addUpdateOilCard + "deleteOilCard" + "/" + cardId;
     var jsondata = {};
     //getlist
     return httpRequest.fetchDelete(url, jsondata)
 }
  /**
  * 设置默认油卡
  */
   export function setOilCard(cardId) {
    var url = config.setDefaultCard + cardId;
    var jsondata = {};
    //getlist
    return httpRequest.fetchPost(url, jsondata)
}


 /**
  * 再次支付
  */
 export function repay(id) {
     var url = config.repay + id;
     var jsondata = {};
     return httpRequest.fetchPost(url, jsondata)
 }

 /**
  * 取消订单
  */
 export function cancelOrder(id) {
     var url = config.cancelOrder + id;
     var jsondata = {};
     return httpRequest.fetchPatch(url, jsondata)
 }

 /**
  * 上线年审下单
  * productNo  产品ID
  * account    充值账号
  * payMode（wechat：微信支付，coupon：券支付, mix：混合支付）
  * name 持卡人(选填)  
  * couponIds  券 ID
  */
 export function annuanVerificationOrder(Data) {
    var url = config.annualVerificationOrder;
   //  var jsondata = {
   //      productNo: Data.productNo,
   //      payMode: Data.payment_mode
   //  };
   //  if (Data.account != undefined & Data.account != "") {
   //      jsondata.account = Data.account;
   //  }
   //  if (Data.name != undefined & Data.name != "") {
   //      jsondata.name = Data.name;
   //  }
    if (Data.couponIds != undefined & Data.couponIds != "") {
        Data.couponIds = Data.couponIds.split(',');
    }
   Data.payMode = Data.payment_mode
    return httpRequest.fetchPostJson(url, Data)
}
/**
 * 取消上线年审订单
 */
export function calcelAnnualVerificationOrder(orderNo) {
    var url = config.annualVerificationOrder + "/" + orderNo + "/status"
    var jsondata = {};
    return httpRequest.fetchPatch(url, jsondata)
}

/**
 * 获取上线年审订单
 */
export function queryAnnualVerificationOrder(orderNo) {
    var url = config.annualVerificationOrder + "/" + orderNo
    var jsondata = {}
    return httpRequest.fetchGet(url, jsondata)
}
/**
 * 创建支付宝账号
 */
export function createAlipayAccountApi(form) {
    return httpRequest.fetchPost(config.alipayAccountURL, form)
}
/**
 * 更新支付宝账号
 */
export function updateAlipayAccountApi(form) {
    return httpRequest.fetchPatch(config.alipayAccountURL, form)
}
/**
 * 创建银行卡账号
 */
export function createBankAccountApi(form) {
    return httpRequest.fetchPost(config.bankAccountURL, form)
}
/**
 * 更新银行卡账号
 */
export function updateBankAccountApi(form) {
    return httpRequest.fetchPatch(config.bankAccountURL, form)
}

export function deleteAccountApi(id) {
    return httpRequest.fetchDelete(config.deleteAccountURL + "?id=" + id)
}

export function updateWxpayAccountApi(form) {
    return httpRequest.fetchPatch(config.wxpayAccountURL, form)
}
